import { ReactNode } from 'react';

type Tone = 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';

const TONE_CLASSES: Record<Tone, string> = {
  primary: 'bg-mist text-slate',
  secondary: 'bg-mist text-muted-2',
  success: 'bg-success-bg text-success',
  warning: 'bg-warning-bg text-warning-ink',
  danger: 'bg-danger-bg text-danger-ink',
  info: 'bg-mist text-slate',
  neutral: 'bg-mist text-slate',
};

interface Props {
  icon: ReactNode;
  tone?: Tone;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const SIZE: Record<'sm' | 'md' | 'lg' | 'xl', string> = {
  sm: 'h-9 w-9 rounded-[12px] text-base',
  md: 'h-11 w-11 rounded-[14px] text-lg',
  lg: 'h-[52px] w-[52px] rounded-[16px] text-2xl',
  xl: 'h-14 w-14 rounded-[18px] text-2xl',
};

export default function IconCircle({ icon, tone = 'primary', size = 'md', className = '' }: Props) {
  return (
    <div className={`inline-flex items-center justify-center ${SIZE[size]} ${TONE_CLASSES[tone]} ${className}`}>
      {icon}
    </div>
  );
}
